export const CLOSE_ALERT = '@alert/CLOSE_ALERT';
export const OPEN_ALERT = '@alert/OPEN_ALERT';
